export default "__VITE_ASSET__DHI0Y66t__"